<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flowDesc: ['第三方车场自助进场的流程大概位：',
            {
              preData: "1、车辆到达进口，道闸提示扫二维码自助，此时开放平台通过接口 ",
              link:  "第三方车场自助进场",
              url: "scanChannelQrCodeInForThi",
              endData: " 向第三方车场获取该次停车的进场随机码等信息；"
            },
            '2、离场：车辆离场时，停车场系统回对车辆进行是否自动扣费校验，若车辆有预存款且为先离场后扣费，则会先开启道闸放行，并通过（临停缴费上报）上报车辆账单给第三方系统进行扣费；若车辆有预存款且为先扣费后离场，' +
            '则会通过（通知第三方缴费（先扣后离））接口通知第三方系统进行扣费，并且第三方系统需在8秒内返回扣费结果信息'
            ],
          flow: [
            {
              name: '通道二维码的生成规则如下:',
              desc: [
                {
                  preData: "https://xxx.com/parkCode/channelId/entranceType，其中 parkCode 为我方平台提供的停车场编号，channelId 为源停车场系统的通道ID，entranceType 为通道类型（1为进口，2为出口）；如 http://127.0.0.1:8080/2KKN88GS/1/1",
                },
              ]
            },
            {
              name: '第三方车场自助进场',
              desc: [
                {
                  preData: "1、车辆到达进口，道闸提示扫二维码自助，此时开放平台通过接口 ",
                  link:  "第三方车场自助进场",
                  url: "scanChannelQrCodeInForThi",
                  endData: " 向第三方车场获取该次停车的进场随机码等信息；"
                },
                {
                  preData: "2、车辆进场，第三方车场将该车次随机码等信息填充到 接口",
                  link:  " 进场上报 ",
                  url: "upThirdParkCarIn",
                  endData: " 的 extendInfo 中，并同步该车的进场信息到开放平台，；"
                },
              ],
              url: '/static/img/self_in_for_third_parking.svg'
            },
            {
              name: '第三方车场自助离场',
              desc: [
                {
                  preData: "1、车辆到达出口口，道闸提示扫二维码自助，此时开放平台通过接口 ",
                  link:  "第三方车场自助离场",
                  url: "scanChannelQrCodeOutForThi",
                  endData: " 向第三方车场获取该次停车匹配到进场记录的离场随加码等信息；"
                },
                {
                  preData: "2、车主缴费后，车辆离场场，第三方车场将该车次随机码等信息填充到 接口",
                  link:  " 离场上报",
                  url: "upThirdParkCarOut",
                  endData: " 的 extendInfo 中，并同步该车的离场信息到开放平台，；"
                },
              ],
              url: '/static/img/self_out_for_third_parking.svg'
            },
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/selfInOutForThiFlow.vue